











import { Component, Prop, Vue, Emit } from "vue-property-decorator";

@Component
export default class MHButton extends Vue {
  @Prop() text!: string;
  @Prop() type!: string;
  @Prop() disabled!: boolean;

  @Emit()
  click() {}
}
